import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

import Axios from "../../services/axios";
import moment from "moment";
import { fetchData } from "../../helpers/fetchData";
import { logout } from "./AuthSlice";

export const getPractionerPatients = createAsyncThunk(
  "practitioner_patientlist",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `/v3/practitioner/getPatientList`,
        payload
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const getVisitsList = createAsyncThunk(
  "patients_visits_list",
  async (payload, { rejectWithValue }) => {
    try {
      const start_date = payload?.start_date || new Date();
      const end_date = payload?.end_date || new Date();
      const response = await Axios.post(`/v3/visit/getPatientVisitByIdV3`, {
        ...payload,
        start_date: moment(start_date).format("YYYY-MM-DD"),
        end_date: moment(end_date).format("YYYY-MM-DD"),
      });
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const getPractionerList = createAsyncThunk(
  "practitioner_list",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/practitioner/get`);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const getPayersList = createAsyncThunk(
  "payers_list",
  async (payload = { category: "" }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/payer/get`, payload);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const getRCMPayersList = createAsyncThunk(
  "rcm_payers_list",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/payer/getRcmList`, payload);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const getCashPayersData = createAsyncThunk(
  "cash_payers_list",
  async (payload = { category: "cash" }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/payer/get`, payload);
      return response.data?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const createNewVisit = createAsyncThunk(
  "create_new_visit",
  async ({ payload, navigate, withOutSlot = false, creditPayload }, { rejectWithValue }) => {
    try {
      const creditAmount = creditPayload?.patient_credit?.patient_credit_amount || 0
      const response = await Axios.post(`/v3/visit/v3/create`, payload);
      if (response?.data?.data?.invoice_no && navigate) {
        navigate(`/print-invoice/${response?.data?.data?.invoice_no}`, {
          state: {
            state: response?.data?.data,
            invoiceNumber: response?.data?.data?.invoice_no,
            navigattion: withOutSlot ? "/create-visit-without-slot" : "/visits",
          },
        });
      } else {
        navigate(withOutSlot ? "/create-visit-without-slot" : "/visits");
      }
      // toast.success(
      //   <div className="text-sm text-white max-w-[360px]">
      //     <p className="font-semibold text-[15px] mb-2 leading-snug">
      //       {response?.data?.message}
      //     </p>
      //     {response?.data?.slot_info && (
      //       <div className="space-y-2 bg-gray-700/70 p-3 rounded-lg">
      //         <p className="flex items-center justify-between text-[14px]">
      //           <span className="text-gray-200">Assigned</span>
      //           <span className="text-green-400 font-semibold">
      //             {response.data.slot_info.assigned_slot}
      //           </span>
      //         </p>
      //         <p className="flex items-center justify-between text-[14px]">
      //           <span className="text-gray-200">Requested</span>
      //           <span className="text-gray-100">
      //             {response.data.slot_info.requested_slot}
      //           </span>
      //         </p>

      //         {response.data.slot_info.reason && (
      //           <p className="text-[13px] text-white italic pt-2">
      //             {response.data.slot_info.reason}
      //           </p>
      //         )}
      //       </div>
      //     )}
      //   </div>,
      //   {
      //     duration: 7000,
      //     className:
      //       "!bg-gray-900 !rounded-xl !shadow-lg !p-4 border border-gray-700 max-w-[400px]",
      //   }
      // );
      // if (creditAmount) {
      //   const res = await fetchData("POST", "/v3/patient/creditBalance/create", creditPayload);
      // }
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error",
        {
          duration: 7000,
        }
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const updateVisitStatus = createAsyncThunk(
  "update_visit_status",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `/v3/practitioner/updateVisitStatus`,
        payload
      );
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const updateVisitItems = createAsyncThunk(
  "update_visit_items",
  async ({ billingPayload, navigate, creditPayload, silent = false }, { rejectWithValue }) => {
    try {
      const creditAmount = creditPayload?.patient_credit?.patient_credit_amount || 0
      const response = await Axios.post(
        `/v3/visit/updatePaymentStatus`,
        billingPayload
      );
      if (!silent) toast.success(response?.data?.message);

      // if (creditAmount && creditPayload) {
      //   const res = await fetchData("POST", "/v3/patient/creditBalance/create", creditPayload);
      // }

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error";

      if (!silent) toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const getVisitType = createAsyncThunk(
  "get_visit_type",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `/v3/visit/checkPatientFollowup`,
        payload
      );
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const cancelVisit = createAsyncThunk(
  "cancelVisit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/visit/cancel`, payload);
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const deleteVisitHistory = createAsyncThunk(
  "deleteVisitHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/visit/deleteHistory`, payload);
      toast.success(response?.data?.message || "Visit history archived and deleted successfully");
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error deleting visit history"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const unarchiveVisitHistory = createAsyncThunk(
  "unarchiveVisitHistory",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/visit/unarchiveHistory`, payload);
      toast.success(response?.data?.message || "Visit history restored successfully");
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error restoring visit history"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const getArchivedVisitsList = createAsyncThunk(
  "getArchivedVisitsList",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/visit/archivedList`, payload);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error fetching archived visits"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const assignNurseToVisit = createAsyncThunk(
  "assign_nurse_to_visit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/visit/assignNurse`, payload);
      toast.success(response?.data?.message || "Visit assigned successfully");
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error assigning visit"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const getNursingStationVisits = createAsyncThunk(
  "get_nursing_station_visits",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/visit/nursingStation`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.error || "Error fetching nursing station visits");
    }
  }
);

export const markNurseCheck = createAsyncThunk(
  "mark_nurse_check",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/visit/nurseCheck`, payload);
      toast.success(response?.data?.message || "Nurse check-in successful");
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error during nurse check-in");
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const getTodaysAppointments = createAsyncThunk(
  "todaysAppointments",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/appointments/list`, payload);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

export const getAllCriticalVitals = createAsyncThunk(
  "get_all_critical_vitals",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/emr/getAllCriticalVitals`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.error || "Error fetching critical vitals");
    }
  }
);

const initialState = {
  selectedVisitData: null,
  isLoading: false,
  isPatientsLoading: false,
  patientsList: null,
  visitsData: null,
  practitionersList: null,
  seletedPatientId: null,
  payersData: null,
  rcmPayersData: null,
  visitCategoryFilter: null,
  visitStatusFilter: null,
  todaysAppointments: null,
  appointmentsLoading: false,
  cashPayers: null,
  visitFilters: null,
  nursingStationVisits: [],
  nursingStationLoading: false,
  nursingStationPagination: null,
  criticalVitals: [],
  criticalVitalsLoading: false,
  archivedVisits: [],
  archivedVisitsLoading: false,
  archivedVisitsPagination: null,
};

const VisitsSlice = createSlice({
  name: "visits",
  initialState,
  reducers: {
    setActivePatientId: (state, action) => {
      state.seletedPatientId = action.payload;
    },
    setVisitFilters: (state, action) => {
      state.visitCategoryFilter = action.payload.category;
      state.visitStatusFilter = action.payload.status;
    },
    setSelectedVisitData: (state, action) => {
      state.selectedVisitData = action.payload;
    },
    setVisitFiltersPayload: (state, action) => {
      state.visitFilters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, (state) => {
        state.visitFilters = null;
        state.selectedVisitData = null;
        state.seletedPatientId = null;
        state.visitCategoryFilter = null;
        state.visitStatusFilter = null;
      })
      .addCase(getPractionerPatients.pending, (state) => {
        state.isPatientsLoading = true;
      })
      .addCase(getPractionerPatients.fulfilled, (state, action) => {
        state.isPatientsLoading = false;
        state.patientsList = action.payload;
      })
      .addCase(getPractionerPatients.rejected, (state) => {
        state.isPatientsLoading = false;
        state.patientsList = null;
      })
      .addCase(getVisitsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVisitsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.visitsData = action.payload;
      })
      .addCase(getVisitsList.rejected, (state) => {
        state.isLoading = false;
        state.visitsData = null;
      })
      .addCase(getPractionerList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPractionerList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.practitionersList = action.payload;
      })
      .addCase(getPractionerList.rejected, (state) => {
        state.isLoading = false;
        state.practitionersList = null;
      })
      .addCase(getPayersList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPayersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.payersData = action.payload;
      })
      .addCase(getPayersList.rejected, (state) => {
        state.isLoading = false;
        state.payersData = null;
      })
      .addCase(getRCMPayersList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRCMPayersList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.rcmPayersData = action.payload;
      })
      .addCase(getRCMPayersList.rejected, (state) => {
        state.isLoading = false;
        state.rcmPayersData = null;
      })
      .addCase(getTodaysAppointments.pending, (state) => {
        state.appointmentsLoading = true;
      })
      .addCase(getTodaysAppointments.fulfilled, (state, action) => {
        state.appointmentsLoading = false;
        state.todaysAppointments = action.payload;
      })
      .addCase(getTodaysAppointments.rejected, (state) => {
        state.appointmentsLoading = false;
        state.todaysAppointments = null;
      })
      .addCase(getCashPayersData.fulfilled, (state, action) => {
        state.cashPayers = action.payload;
      })
      .addCase(getCashPayersData.rejected, (state) => {
        state.cashPayers = null;
      })
      .addCase(getNursingStationVisits.pending, (state) => {
        state.nursingStationLoading = true;
      })
      .addCase(getNursingStationVisits.fulfilled, (state, action) => {
        state.nursingStationLoading = false;
        const resp = action.payload || {};
        const newVisits = resp?.data || [];
        const { page: requestedPage } = action.meta.arg || {};
        const responsePage = resp?.page || requestedPage || 1;
        if (responsePage === 1) {
          state.nursingStationVisits = newVisits;
        } else {
          state.nursingStationVisits = [...state.nursingStationVisits, ...newVisits];
        }
        const totalPages =
          resp?.total_pages ||
          Math.ceil(
            (resp?.totalCount || resp?.total_records || 0) /
              (resp?.perPage || resp?.per_page || 50)
          );
        state.nursingStationPagination = {
          TotalPages: totalPages,
          CurrentPage: responsePage,
          summary: resp?.summary || null
        };
      })
      .addCase(getNursingStationVisits.rejected, (state) => {
        state.nursingStationLoading = false;
      })
      .addCase(getAllCriticalVitals.pending, (state) => {
        state.criticalVitalsLoading = true;
      })
      .addCase(getAllCriticalVitals.fulfilled, (state, action) => {
        state.criticalVitalsLoading = false;
        state.criticalVitals = action.payload?.data || [];
      })
      .addCase(getAllCriticalVitals.rejected, (state) => {
        state.criticalVitalsLoading = false;
        state.criticalVitals = [];
      })
      .addCase(getArchivedVisitsList.pending, (state) => {
        state.archivedVisitsLoading = true;
      })
      .addCase(getArchivedVisitsList.fulfilled, (state, action) => {
        state.archivedVisitsLoading = false;
        state.archivedVisits = action.payload?.data || [];
        state.archivedVisitsPagination = {
          total: action.payload?.totalCount || 0,
          page: action.payload?.page || 1,
          limit: action.payload?.perPage || 20,
          total_pages: Math.ceil((action.payload?.totalCount || 0) / (action.payload?.perPage || 20)),
        };
      })
      .addCase(getArchivedVisitsList.rejected, (state) => {
        state.archivedVisitsLoading = false;
        state.archivedVisits = [];
      });
  },
});

export const {
  setActivePatientId,
  setVisitFilters,
  setSelectedVisitData,
  setVisitFiltersPayload,
} = VisitsSlice.actions;
export default VisitsSlice.reducer;
